import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchMyAllocator,
  fetchMyAllocatorFailed,
  fetchMyAllocatorSucceeded,
} from 'redux/slice/lenders/MyLenders.slice';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { ApiStatusCodes } from '../../../services/api/apiStatusCode';
import { allocator } from '../../../services/api/endPoints';
import { HTTPClient } from '../../../services/api/http-client';
import { IFetchMyAllocatorResponse } from './Allocator.types';

export function* fetchMyAllocatorSaga({
  payload,
}: PayloadAction<AllocatorListPayload>) {
  try {
    const { agencyId } = payload;
    // Simulate API call with a 10-second delay using Redux Saga's `delay` effect
    const result: IFetchMyAllocatorResponse = yield HTTPClient.GetRequest(
      allocator.GET_ALLOCATOR_LIST(agencyId)
    );

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchMyAllocatorSucceeded(data?.allocatorList));
    } else {
      throw new Error();
    }
  } catch (error) {
    // Handle API call failure or network errors

    yield put(
      fetchMyAllocatorFailed({
        error: {
          message: 'An error occurred while fetching lenders.',
        },
      })
    );
  }
}

export function* watchMyLenderSaga() {
  yield takeLatest(fetchMyAllocator.type, fetchMyAllocatorSaga);
}
